import { Box, theme } from '@dtx-company/shared-components'
import { styled } from '@mui/system'

export const FAQBadgeContainer = styled(Box)`
  background: ${theme.colors.secondary.backgroundActive};
  padding: 8px 30px;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  p {
    margin: 0;
  }
  word-wrap: normal;
  text-align: center;
  a {
    color: ${theme.colors.primary.flowBlue};
    text-decoration: underline;
  }
`
